export default __webpack_public_path__ + "static/media/8.401a1d1c.webp";